import {Box} from "@material-ui/core";
import React from "react";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import {useCardStyles} from "../../styles/card";


export default function ProviderMeter(props) {
    const classes = useCardStyles();
    const {value, provider} = props;

    return <Box display="flex"
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
    >
        <CardMedia className={classes.mediaWidget} image={`https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/integrations/${provider}.png`}/>
        <Typography style={{marginLeft: 10, marginRight: 10}} variant="h3">
            {(value)?.toFixed(1)}
        </Typography>
        <CardMedia className={classes.mediaWidgetStar} image={"https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/social/star.png"}/>
    </Box>
}
